import { render, staticRenderFns } from "./ProjectServiceChargeEdit.vue?vue&type=template&id=6a00307a&"
import script from "./ProjectServiceChargeEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectServiceChargeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports